export default __webpack_public_path__ + "static/media/backdrop_education.0372cabf.png";